import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const OpenButton = styled(Button)(({ theme }) => ({
  alignSelf: "center",
  minWidth: 260,
  textTransform: "none",
  fontWeight: 700,
  fontSize: 15,
  padding: theme.spacing(1.5, 4),
  borderRadius: theme.shape.borderRadius,
}));

export const Panel = styled(Box)(({ theme }) => ({
  alignSelf: "stretch",
  marginTop: theme.spacing(1.5),
  padding: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
}));

export const Head = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const Copied = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  color: theme.palette.success.main,
}));

export const Failed = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  color: theme.palette.error.main,
}));

export const Code = styled("textarea")(({ theme }) => ({
  width: "100%",
  minHeight: 96,
  resize: "vertical",
  boxSizing: "border-box",
  padding: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  fontFamily: "monospace",
  fontSize: 12,
  lineHeight: 1.5,
}));
